<template>
  <Container 
    v-if="dbinfo && dbinfo.dbtitle" 
    :title="dbinfo.dbtitle" 
    :returnBtn="false" 
    :addBtn="openAddDialog"
  >
    <DbTableView 
      :key="dbname" 
      ref="tableRef" 
      v-if="dbname" 
      :dbname="dbname" 
      @edit="openEditDialog" 
    />

    <!-- 添加/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      v-model="dialogVisible"
      :width="dialogWidth"          
      style="max-width: 1600px;"    
      top="5vh"
      @close="closeDialog"
      destroy-on-close
      :close-on-click-modal="false"
    >
      <div style="max-height: 70vh; overflow-y: auto; padding-right: 10px;">
        <el-form :model="form" label-width="auto" label-position="top" ref="formRef">
          <el-form-item
            v-for="(item, k) in fields"
            :key="'field_' + k"
            :label="item.fielddesc || item.fieldname"
            style="width: 100%;"
          >
            <!-- string / hide -->
            <div v-if="item.render == 'string' || item.render == 'hide'" style="width: 100%; max-width: 500px;">
              <el-input v-model="form[item.name]" :placeholder="'请填写' + item.fielddesc" />
            </div>

            <!-- number -->
            <div v-if="item.render == 'number'" style="width: 100%; max-width: 500px;">
              <el-input-number style="width: 100%;" v-model="form[item.name]" :placeholder="'请填写' + item.fielddesc" />
            </div>

            <!-- date -->
            <div v-if="item.render == 'date'" style="width: 100%; max-width: 500px;">
              <el-date-picker
                @change="(val) => { form[item.name] = val ? val.valueOf() : null }"
                style="width: 100%;"
                v-model="form[item.name]"
                type="date"
                :placeholder="'请选择' + item.fielddesc"
                value-format="x"
              />
            </div>

            <!-- datetime -->
            <div v-if="item.render == 'datetime'" style="width: 100%; max-width: 500px;">
              <el-date-picker
                @change="(val) => { form[item.name] = val ? val.valueOf() : null }"
                style="width: 100%;"
                v-model="form[item.name]"
                type="datetime"
                :placeholder="'请选择' + item.fielddesc"
                value-format="x"
              />
            </div>

            <!-- dict -->
            <div v-if="item.render == 'dict'" style="width: 100%; max-width: 500px;">
              <FormDictItem :name="item.name" :dbname="item.dict" :form="form" :fieldname="item.fielddesc" />
            </div>

            <!-- enum -->
            <div v-if="item.render == 'enum'" style="width: 100%; max-width: 500px;">
              <el-select v-model="form[item.name]" :placeholder="'请选择' + item.fielddesc" style="width: 100%;">
                <el-option
                  v-for="(eitem, ek) in (item.enums || '').split(',')"
                  :key="'enum_' + ek"
                  :label="eitem"
                  :value="eitem"
                />
              </el-select>
            </div>

            <!-- database -->
            <div v-if="item.render == 'database'" style="width: 100%; max-width: 500px;">
              <FormDbItem :name="item.name" :dbname="item.dbname" :form="form" :fieldname="item.fielddesc" />
            </div>

            <!-- image -->
            <div v-if="item.render == 'image'" style="width: 100%;">
              <FormImageItem :name="item.name" :form="form" :fieldname="item.fielddesc" />
            </div>

            <!-- file -->
            <div v-if="item.render == 'file'" style="width: 100%;">
              <FormFileItem :name="item.name" :form="form" :fieldname="item.fielddesc" />
            </div>

            <!-- map -->
            <div v-if="item.render == 'map'" style="width: 100%;">
              <FormMapItem :name="item.name" :form="form" :fieldname="item.fielddesc" />
            </div>

            <!-- html -->
            <div v-if="item.render == 'html'" style="width: 100%; margin-bottom: 20px;">
              <FormEditItem :value="form[item.name]" :form="form" :name="item.name" />
            </div>
          </el-form-item>
        </el-form>
      </div>

      <template #footer>
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="loading">确定</el-button>
      </template>
    </el-dialog>
  </Container>
  <div v-else-if="!loading && !error" style="padding: 40px; text-align: center; color: #999;">
    请从菜单选择数据表
  </div>
  <div v-else-if="error" style="padding: 40px; text-align: center; color: #f56c6c;">
    {{ error }}
  </div>
</template>

<script>
import { sub, pub } from '../../../../common/event';

export default {
  data() {
    return {
      dbinfo: null,
      dbname: '',
      dialogVisible: false,
      dialogTitle: '',
      editId: null,
      form: {},
      fields: [],
      loading: false,
      error: '',
    }
  },
  watch: {
    // 直接监听路由 query 参数变化
    '$route.query.dbname': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.dbname = newVal
          this.init(newVal)
        } else {
          this.error = '未指定数据表'
          this.dbinfo = null
        }
      }
    }
  },
  computed: {
    dialogWidth() {
      if (!this.fields || this.fields.length === 0) {
        return '600px'; // 默认宽度
      }
      // 判断是否包含需要宽屏展示的控件
      const hasLargeField = this.fields.some(item => 
        ['html', 'image', 'file', 'map'].includes(item.render)
      );
      // 包含富文本、图片等给 80%，普通表单给 600px
      return hasLargeField ? '80%' : '600px';
    }
  },
  mounted() {
    // 兼容旧的事件通知方式
    sub('fengdatabaselist', (path) => {
      const match = path.match(/[?&]dbname=([^&]+)/)
      if (match) {
        const newDbname = match[1]
        if (newDbname !== this.dbname) {
          this.dbname = newDbname
          this.init(newDbname)
        }
      }
    })
  },
  methods: {
    // 初始化数据表信息及字段
    async init(dbname) {
      if (!dbname) {
        this.error = '缺少数据表名'
        return
      }
      this.loading = true
      this.error = ''
      try {
        // 1. 获取表信息
        const infoRes = await this.$api.feng.getDbinfoByName(dbname)
        if (infoRes && infoRes.success && infoRes.data) {
          this.dbinfo = infoRes.data
        } else {
          this.error = '数据表不存在或未配置'
          this.dbinfo = null
          this.loading = false
          return
        }
    
        // 2. 获取字段定义
        const fieldRes = await this.$api.feng.getmodelinfo(dbname)
        if (fieldRes && fieldRes.success && fieldRes.data) {
          this.fields = fieldRes.data.fields || [] 
        } else {
          this.fields = []
        }
      } catch (e) {
        console.error('初始化失败', e)
        this.error = '加载失败，请重试'
      } finally {
        this.loading = false
      }
    },

    openAddDialog() {
      if (!this.dbinfo) return
      this.editId = null
      this.dialogTitle = '添加' + this.dbinfo.dbtitle
      this.form = {}
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef?.clearValidate()
      })
    },

    async openEditDialog(row) {
      if (!row || !row.id) return
      this.editId = row.id
      this.dialogTitle = '编辑' + this.dbinfo.dbtitle
      try {
        const ret = await this.$api.feng.get(this.dbname, row.id)
        if (ret && ret.success && ret.data) {
          this.form = ret.data
        } else {
          this.$message.error('获取数据失败')
          return
        }
      } catch (error) {
        console.error('获取数据失败', error)
        this.$message.error('获取数据失败')
        return
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef?.clearValidate()
      })
    },

    closeDialog() {
      this.dialogVisible = false
      this.editId = null
      this.form = {}
    },

    submitForm() {
      this.$refs.formRef?.validate(async (valid) => {
        if (!valid) return

        this.loading = true
        try {
          let ret
          if (this.editId) {
            ret = await this.$api.feng.put(this.dbname, { ...this.form, id: this.editId })
          } else {
            ret = await this.$api.feng.post(this.dbname, this.form)
          }

          if (ret && ret.success) {
            pub('success_message', this.editId ? '编辑成功' : '添加成功')
            this.closeDialog()
            this.refreshTable()
          } else {
            this.$message.error(ret?.message || '操作失败')
          }
        } catch (error) {
          console.error('提交失败:', error)
          this.$message.error('请求失败，请重试')
        } finally {
          this.loading = false
        }
      })
    },

    refreshTable() {
      if (this.$refs.tableRef && typeof this.$refs.tableRef.loadData === 'function') {
        this.$refs.tableRef.loadData()
      } else {
        pub('refreshDbTable', { dbname: this.dbname })
      }
    }
  }
}
</script>

<style scoped>
</style>